interface WithTimeoutOptions {
  timeout?: number;
  label?: string;
}

export const withTimeout = async <T>(request: () => Promise<T>, options: WithTimeoutOptions = {}): Promise<T> => {
  const { timeout = 30000, label } = options;

  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  const timeoutErrorRequest = new Promise<never>((_resolve, reject) => {
    timeoutId = setTimeout(() => {
      reject(new Error(label ? `Request timed out: ${label} (${timeout}ms)` : `Request timed out in ${timeout}ms`));
    }, timeout);
  });

  try {
    const result = await Promise.race([request(), timeoutErrorRequest]);

    return result;
  } finally {
    clearTimeout(timeoutId);
  }
};
